import React from 'react'

import style from './Detail.module.scss'

const Detail = ({
  param,
  microcopy
}) => (
  <div className={ style.details }>
    { param.example && !param.hasAdditionalProperties && (
      <>
        <label>
          {  microcopy.text('reference.parameter_details.example') }              
        </label>
        <code>{ param.example }</code>
      </>
    )}
    { param.default && (
      <>
        <label>{ microcopy.text('reference.parameter_details.default') }</label>
        <code>{ param.default }</code>
      </>
    )}

    { param.range && (
      <>
        <label>{ microcopy.text('reference.parameter_details.range') }</label>
        <code>{ param.range }</code>
      </>
    )}
    
    { param.maxLength && (
      <>
        <label>{ microcopy.text('reference.parameter_details.max_length') }</label>
        <code>{ param.maxLength }</code>
      </>
    )}
  </div>
)

export default Detail